import React, { useState } from 'react';
// import axios from 'axios';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { TextInput } from 'components/layout/FormElement';
import { useAddTimeSheetMutation } from '../../userBatchSlice';

const userResponseStyle =
  'p-4 bg-gray-500 text-white text-center shadow rounded';

const AddTimeTable = ({ batchDetails, weekDates, selectedWeek }: any) => {
  const batchId = batchDetails._id;
  const [serverResponse, setServerResponse] = useState('');

  const catagory = [
    ' Mentor Meeting',
    'Coach Connect',
    'Internship Work',
    'Self Learning',
    'Career Cafe',
  ];

  const mytimeValue = weekDates.map((myDate: any) => {
    return {
      date: moment(myDate.date, 'DD/MM/YYYY'),
      hours: '',
    };
  });

  const myReport = catagory.map((cat) => {
    return {
      eventCode: cat,
      description: '',
      timeValues: mytimeValue,
    };
  });

  const totalAmount = function (data: any, day: any) {
    const mydata = data.map((cat: any) => {
      return cat.timeValues[day].hours;
    });
    var totalSum = 0;
    for (var i = 0; i < mydata.length; i++) {
      if (mydata[i] !== '') {
        totalSum += mydata[i];
      }
    }
    return totalSum;
  };

  const checkForDaily = (report: any) => {
    for (let i = 0; i < 5; i++) {
      if (totalAmount(report, i) > 8) {
        return true;
      }
    }
    return false;
  };

  const [submitTimeSheet] = useAddTimeSheetMutation();

  // Due to missed deadline, you can submit only once

  return (
    <div>
      {/* <Deadline deadline={weekDates[4]} batchDetails={batchDetails} /> */}
      <Formik
        enableReinitialize={true}
        initialValues={{
          batchId: batchId,
          week: selectedWeek,
          report: myReport,
        }}
        validationSchema={Yup.object({
          report: Yup.array().of(
            Yup.object().shape({
              timeValues: Yup.array().of(
                Yup.object().shape({
                  hours: Yup.number()
                    .min(0, 'daily hours 0-8')
                    .max(8, 'daily hours 0-8'),
                })
              ),
            })
          ),
        })}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setServerResponse('');
          if (checkForDaily(values.report)) {
            alert('Daily Working hours Not more then 8');
            setSubmitting(false);
          } else {
            submitTimeSheet(values)
              .unwrap()
              .then((res: any) => {
                setServerResponse(res.data.msg);
                setSubmitting(false);
              })
              .catch(function (response: any) {
                setServerResponse('Error! Could not process your request.');
                setSubmitting(false);
              });
          }
        }}
      >
        {({ values, setFieldValue, isSubmitting }) => (
          <Form className='space-y-12 bg-gray-50 p-4 rounded-xl'>
            <div>
              <table className='table-fixed border-collapse border border-gray-400'>
                <thead>
                  <tr className='text-primary'>
                    <th className='w-3/12 border-collapse border border-gray-300'>
                      Category
                    </th>
                    <th className='w-4/12  border-collapse border border-gray-300'>
                      Description
                    </th>
                    {weekDates.map((myDate: any) => {
                      return (
                        <th
                          key={myDate.day}
                          className='w-1/12 p-2  border-collapse border border-gray-300'
                        >
                          <p>{myDate.day}</p>
                          <p>{myDate.date}</p>
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {values.report.map((cat, index) => {
                    return (
                      <tr className='text-center' key={index}>
                        <td className='py-3 border-collapse border border-gray-300 text-primary'>
                          {cat.eventCode}
                        </td>
                        <td className='py-3 border-collapse border border-gray-300'>
                          <TextInput
                            name={`report[${index}].description`}
                            type='text'
                            placeholder='Description'
                            className='w-full p-2'
                          />
                        </td>

                        {cat.timeValues.map((date: any, idx: any) => {
                          return (
                            <td
                              key={idx}
                              className='py-3 border-collapse border border-gray-300'
                            >
                              <TextInput
                                name={`report[${index}].timeValues[${idx}].hours`}
                                type='number'
                                placeholder='Hours'
                                className='w-full p-2'
                              />
                              {totalAmount(values.report, idx) > 8 && (
                                <div className='text-sm text-red-400'>
                                  Daily hour must be less then 8
                                </div>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}

                  <tr>
                    <td></td>
                    <td className='text-primary'>
                      Total Hours ={' '}
                      {totalAmount(values.report, 0) +
                        totalAmount(values.report, 1) +
                        totalAmount(values.report, 2) +
                        totalAmount(values.report, 3) +
                        totalAmount(values.report, 4)}
                      /40
                    </td>
                    <td className='py-3 text-center border-collapse border border-gray-300'>
                      {totalAmount(values.report, 0)}
                    </td>
                    <td className='py-3 text-center border-collapse border border-gray-300'>
                      {totalAmount(values.report, 1)}
                    </td>
                    <td className='py-3 text-center border-collapse border border-gray-300'>
                      {totalAmount(values.report, 2)}
                    </td>
                    <td className='py-3 text-center border-collapse border border-gray-300'>
                      {totalAmount(values.report, 3)}
                    </td>
                    <td className='py-3 text-center border-collapse border border-gray-300'>
                      {totalAmount(values.report, 4)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className='flex justify-end gap-4'>
              <div className='font-semibold mr-4 mt-1 text-lg'>
                Deadline: {weekDates[4].day}, {weekDates[4].date}
              </div>
              <button
                type='submit'
                className='shadow bg-primary text-white px-4 py-1 rounded hover:bg-primary-light'
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Processing...' : 'Submit'}
              </button>
            </div>
            {serverResponse && (
              <div className={userResponseStyle}>{serverResponse}</div>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddTimeTable;
